import {
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import catalogPlugin from '@backstage/plugin-catalog/alpha';

export const catalogModule = createFrontendModule({
  pluginId: catalogPlugin.pluginId,
  extensions: [
    // ── Route (→ app/routes) ────────────────────────────────
    PageBlueprint.make({
      params: {
        path: '/catalog',
        noHeader: true,
        routeRef: catalogPlugin.routes.catalogIndex,
        loader: () =>
          import('../components/catalog/CustomCatalogPage').then(m => (
            <m.CustomCatalogPage />
          )),
      },
    }),
  ],
});
